import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { akvToModel, akvToResource } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { NativeMongoDbLinkedService } from 'app/model/linkedservice/native-mongo-db.linkedservice';
import { Constants } from '../../../shared/shared-constants';
import { ITridentResource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(NativeMongoDbLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                connectionString: 'secret',
                database: '*',
                encryptedCredential: '*'
            }
        }
    }
})

export class NativeMongoDbLinkedServiceAdapter extends LinkedServiceAdapter<NativeMongoDbLinkedService> {
    protected modelConstructor(): new () => NativeMongoDbLinkedService {
        return NativeMongoDbLinkedService;
    }

    protected model(): IModel {
        return NativeMongoDbLinkedService.MODEL;
    }

    protected override toAzureTypeProperties = (tridentResource: ITridentResource):Partial<Model.NativeMongoDbLinkedServiceTypeProperties> => {
        try {
            const connectionDetails = JSON.parse(tridentResource.connectionDetails);
            const extensionDataSourcePath = JSON.parse(connectionDetails.extensionDataSourcePath);
            return {
                connectionString: extensionDataSourcePath.server
            }
        } catch (e) {
            return {};
        }
    };

    protected async propertiesToResourceAsync(linkedService: NativeMongoDbLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.NativeMongoDbLinkedService;
        properties.type = Metamodel.modelFor(NativeMongoDbLinkedService).name;
        const connectionString: string | Model.SecretBase = !linkedService.enableAKV ?
            this._connectionStringToResource(linkedService.connectionString) : akvToResource(linkedService.referedAKV, this.context);
        if (linkedService != null) {
            properties.typeProperties = {
                connectionString,
                database: linkedService.databaseName
            };
        }

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: NativeMongoDbLinkedService): Promise<NativeMongoDbLinkedService> {
        const properties = linkedServiceResource.properties as Model.NativeMongoDbLinkedService;
        linkedService.connectionString = undefined;
        linkedService.databaseName = undefined;
        linkedService.enableAKV = false;
        linkedService.referedAKV = undefined;

        if (properties.typeProperties.connectionString
            && (properties.typeProperties.connectionString as Model.SecretBase).type === 'AzureKeyVaultSecret') {
            linkedService.referedAKV = akvToModel(properties.typeProperties.connectionString as Model.AzureKeyVaultSecretReference, this.context);
            linkedService.enableAKV = true;
        } else if (properties.typeProperties.connectionString != null) {
            linkedService.connectionString = Constants.maskedCredential;
        }
        linkedService.databaseName = properties.typeProperties.database;
        return linkedService;
    }
}
